import React, { useState } from "react";
import { Card, Text, Button, Image } from "../../design";
import { translate, translateDateEpoch } from "../../utils/translations";
import {
    getCurrencyDisplayInternationalized,
    getVariantTitleDisplay,
} from "../../utils/helpers";
import { addDays, fromUnixTime } from "date-fns";
import { useLoop } from "../loop-provider";

function SubscriptionOverviewCard(props: any) {
    const [showProductDetails, setshowProductDetails] = useState(false);
    const { locale, country, preferences } = useLoop();
    const deliveryDate = props.contract.chargeOffset ? addDays(fromUnixTime(props.contract.next_billing_date), props.contract.chargeOffset)?.getTime() / 1000 : props.contract.next_billing_date

    return (
        <Card className="position-relative">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <Text.P2 className="loop-text-muted">
                        {"#" + props.contract.shopify_id}
                    </Text.P2>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <Text.P1>
                        {translate("next_order_date_label", {
                            next_billing_date: translateDateEpoch(
                                props.contract.next_billing_date,
                                preferences.date_display_internationalization_format,
                                locale,
                                country,
                            ),
                        }) + " "}
                        <strong>
                            {translateDateEpoch(
                                deliveryDate,
                                preferences.date_display_internationalization_format,
                                locale,
                                country,
                            )}
                        </strong>
                    </Text.P1>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Text.P2>
                        <strong id="loop-subscription-list-total-price">
                            {getCurrencyDisplayInternationalized(props.contract.currency_code, locale, country, props.contract.total_line_item_discounted_price)}
                        </strong>
                        <span id="loop-subscription-list-plus-separator">{" + "}</span>
                        <span id="loop-subscription-list-shipping-cost">
                            {getCurrencyDisplayInternationalized(props.contract.delivery_price_currency_code, locale, country, props.contract.delivery_price) +
                                " " +
                                translate("shipping_label")}
                        </span>
                    </Text.P2>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <Button
                        size="sm"
                        variant="underline"
                        onClick={() => {
                            setshowProductDetails(!showProductDetails);
                        }}
                    >
                        {!showProductDetails
                            ? translate(
                                "merge_subscription_show_product_details",
                            )
                            : translate(
                                "merge_subscription_hide_product_details",
                            )}
                    </Button>
                </div>
            </Card.Body>
            {showProductDetails ? (
                <Card.Footer>
                    {props.contract.line_items.map(
                        (li: any, liIndex: number) => {
                            let _break = null;
                            if (liIndex > 0 && liIndex % 2 == 0) {
                                _break = <div className="w-100 d-block"></div>;
                            }
                            return (
                                <React.Fragment key={liIndex}>
                                    {_break}
                                    <div className="col-md">
                                        <div className="d-flex align-items-center p-2">
                                            <Image.ProductImage
                                                size="sm"
                                                className="me-3 flex-shrink-0"
                                                src={li.variant_image}
                                            />
                                            <div>
                                                <Text.P1>{li.title}</Text.P1>
                                                <Text.P2>
                                                    {getVariantTitleDisplay(
                                                        li.variant_title,
                                                    )}
                                                </Text.P2>
                                                <Text.P2>
                                                    {getCurrencyDisplayInternationalized(props.contract.currency_code, locale, country, li.discounted_price / li.quantity)}
                                                    {" x "}
                                                    {li.quantity}
                                                </Text.P2>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        },
                    )}
                </Card.Footer>
            ) : null}
        </Card>
    );
}

export default SubscriptionOverviewCard;
